export default "__VITE_ASSET__CTxo5dCe__"